import classNames from 'classnames'

export const Container = ({ type, children, className, vertical }) => {
  return (
    <div
      className={classNames([
        vertical
          ? 'lg:flex-row lg:pt-0 flex-col pt-6'
          : 'flex-col pt-6 2xl:pt-10',
        type === 'collection'
          ? 'h-full'
          : type === 'leaderboard' || 'missionDayTwo'
          ? 'lg:h-fit lg:min-h-[90%] overflow-auto'
          : 'h-full lg:h-fit',
        'max-h-full bg-black mx-auto bg-opacity-80 h-full mt-5 w-4/5 rounded-xl overflow-hidden content-wrapper flex items-center border-half border-gold relative',
        className,
      ])}
    >
      {children}
    </div>
  )
}
